import { render } from "./SlidebarDoctor.vue?vue&type=template&id=012eeaeb&scoped=true&ts=true"
import script from "./SlidebarDoctor.vue?vue&type=script&lang=ts"
export * from "./SlidebarDoctor.vue?vue&type=script&lang=ts"

import "../assets/scss/component/slidebar.scss?vue&type=style&index=0&id=012eeaeb&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012eeaeb"]])

export default __exports__